import ApplicationUploadDocumentsTeacherWrapper from './ApplicationUploadDocumentsTeacherWrapper.page';

export default ApplicationUploadDocumentsTeacherWrapper;